import moment from 'moment';
import React from 'react';
import Logo from 'containers/Logo';
import { Button, Glyphicon } from 'react-bootstrap';
import { cbrsSupportEmail, ctiaSupportEmail } from 'helpers/Emails';

import 'containers/Footer/style.css';

const Footer = ({ user }) => {
  const currYear = moment().format('YYYY');
  const email = "jorg.brakensiek@ongoalliance.org";
  //const email = user ? ctiaSupportEmail : cbrsSupportEmail;
  return (
    <div className="footer">
      <Logo size="small" />
      <p>&copy;{currYear} CBRS Alliance. All rights reserved.</p>
      <div className="contactUs">
        <a href={`mailto:${email}`}>
          <Button bsSize="small">
            <Glyphicon glyph="envelope" /> Contact Us
          </Button>
        </a>
      </div>
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/containers/Footer/index.js